/**
 * crisis.ts — shared crisis signal detection for session phases.
 *
 * Used inline during Story (Ground) and Expression (Feel) phases so that
 * users who write crisis-level content see 988 / Crisis Text Line resources
 * immediately, without being blocked from continuing.
 *
 * Detection is intentionally conservative — false positives (showing
 * resources when not needed) are far safer than false negatives.
 * Once shown, resources stay visible for the remainder of the phase.
 */

const CRISIS_SIGNALS = [
  'kill myself',
  'end my life',
  'want to die',
  'suicide',
  'suicidal',
  'self-harm',
  'self harm',
  'hurt myself',
  'not worth living',
  "can't go on",
  'cannot go on',
  "don't want to be here",
  'no reason to live',
  'better off dead',
  'end it all',
]

/** Returns true if the text contains any crisis-level signal. */
export function detectCrisis(text: string): boolean {
  const lower = text.toLowerCase()
  return CRISIS_SIGNALS.some(s => lower.includes(s))
}
